/* eslint-disable no-restricted-syntax,consistent-return */
import { isEmpty, maxBy } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { getColorForPalletteCandidate } from '@/components/pages/page-election-map-new/election-map/election-map.vue';
import Contract from '@/models/contract';

export default {
  data() {
    return {
      ready: false,
      showTooltip: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('market', ['mapStateDataSenate', 'marketMapTooltipVisible']),
    classModifiers() {
      return {
        'election-map-special': true,
        'election-map-special--tooltip-visible': this.marketMapTooltipVisible,
      };
    },
    legendStyleModifiers() {
      return {
        background: this.color,
      };
    },
    color() {
      return this.pallette.color;
    },
    targetContract() {
      return maxBy(this.mapStateDataSenate.GA2.contracts || [], i => i.lastTradePrice);
    },
    targetContractInstance() {
      return new Contract(this.targetContract);
    },
    pallette() {
      const pallette = getColorForPalletteCandidate(this.targetContract.contractName);
      const factor = pallette[0].from + this.targetContract.lastTradePrice;
      for (const item of pallette) {
        if (factor <= item.to) {
          return item;
        }
      }
    },
  },
  watch: {
    mapStateDataSenate: {
      handler: 'mapStateDataHandler',
      immediate: true,
    },
  },
  methods: {
    onClick() {
      if (this.isLayoutMobile) {
        const marketId = this.mapStateDataSenate.GA2.marketId;
        if (marketId) {
          window.location.href = `https://www.predictit.org/markets/detail/${marketId}`;
        }
      }
    },
    onMouseEnter() {
      this.showTooltip = true;
    },
    onMouseLeave() {
      this.showTooltip = false;
    },
    mapStateDataHandler(value) {
      if (!isEmpty(value)) {
        this.ready = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-election-map-new/election-map-special/election-map-special.js